import { FieldArray, useFormContext } from '@calendly/form';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useCallback, useEffect, useState, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { errorsSelector } from 'features/invite_flow/selectors';
import { removeBackendError } from 'features/invite_flow/slice';
import { isAdminOrOwnerSelector, isGroupAdminSelector } from 'selectors/current_user';
import { ErrorsNotification, useBulkOfErrorMessages } from '../../steps/add_emails_step/errors';
import { TagContainer } from '../../steps/add_emails_step/tag';
import { useNewAdminModal } from '../use-new-admin-modal';
const wrapperIsPhoneCss = "wvv3ezd";
const wrapperIsNewAdminModalCss = "w5ez91f";
const wrapperCss = "wpbny0h";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  const isNewAdminModal = useNewAdminModal();
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperIsPhoneCss]: isPhone,
    [wrapperIsNewAdminModalCss]: isNewAdminModal
  }, props.className)} />;
});
const fieldContainerIsPhoneCss = "f1wovbbm";
const fieldContainerCss = "fbna1up";
const FieldContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(fieldContainerCss, {
    [fieldContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const fieldArrayWrapperErrorCss = "f1m1j8tz";
const fieldArrayWrapperCss = "f466r1p";
const FieldArrayWrapper = forwardRef((props, ref) => {
  const {
    error,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fieldArrayWrapperCss, {
    [fieldArrayWrapperErrorCss]: error
  }, props.className)} />;
});
const emailErrorCss = "eakla7z";
const EmailError = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emailErrorCss, props.className)} />;
});
export const EmailTagsField = ({
  maxSeats,
  showNoEmailsError,
  inlineRoleSelect,
  onChange,
  singleRow = false,
  placeholderText = ''
}) => {
  const dispatch = useDispatch();
  const backendErrors = useSelector(errorsSelector);
  const {
    errors: {
      invitations: errors = []
    },
    setFieldError
  } = useFormContext();
  const errorMessages = useBulkOfErrorMessages(errors);
  const {
    values: {
      invitations
    }
  } = useFormContext();
  const [tooManyEmails, setTooManyEmails] = useState(false);
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector);
  const isGroupAdmin = useSelector(isGroupAdminSelector);
  useEffect(() => {
    if (invitations.length > 0) {
      onChange();
    }
    if (invitations.length > maxSeats) {
      setTooManyEmails(true);
    } else {
      setTooManyEmails(false);
    }
  }, [invitations, maxSeats, onChange]);
  useEffect(() => {
    if (!Object.keys(backendErrors).length) return;
    Object.entries(backendErrors).forEach(([field, error]) => {
      setFieldError(field, Array.isArray(error) ? error[0] : error);
    });
  }, [setFieldError, errors, backendErrors]);
  const removeBackendErrorHandler = useCallback(fieldName => {
    if (Object.keys(backendErrors).includes(fieldName)) {
      dispatch(removeBackendError(fieldName));
    }
  }, [backendErrors, dispatch]);
  const emailsRef = useCallback(node => {
    if (node) {
      node.scrollIntoView();
    }
  }, []);
  return <Wrapper ref={emailsRef}>
      <FieldContainer>
        <label htmlFor="invite-user-modal-input-field">
          <FieldArrayWrapper error={tooManyEmails || errors.length > 0}>
            <FieldArray name="invitations" render={helpers => <TagContainer {...helpers} onChangeOrRemove={removeBackendErrorHandler} singleRow={singleRow} placeholderText={placeholderText} inlineRoleSelect={inlineRoleSelect} inputId="invite-user-modal-input-field" />} />
          </FieldArrayWrapper>
        </label>
        {errorMessages.length > 0 && <ErrorsNotification errors={errorMessages} />}
        {showNoEmailsError && <EmailError>{I18n.t('publisher.add_users_modal.no_emails_error')}</EmailError>}
        {tooManyEmails && <EmailError>
          {maxSeats === 1 && I18n.t('publisher.add_users_modal.insufficient_seats_error.seat_admin')}
          {maxSeats > 1 && I18n.t('publisher.add_users_modal.insufficient_seats_error.seats_admin', {
          count: maxSeats
        })}
          <br />
          {isAdminOrOwner && invitations.length - maxSeats === 1 && HtmlParser(I18n.t('publisher.add_users_modal.insufficient_seats_error.billing_or_delete_email'))}
          {isAdminOrOwner && invitations.length - maxSeats > 1 && HtmlParser(I18n.t('publisher.add_users_modal.insufficient_seats_error.billing_or_delete_emails', {
          count: invitations.length - maxSeats
        }))}
          {isGroupAdmin && !isAdminOrOwner && invitations.length - maxSeats === 1 && I18n.t('publisher.add_users_modal.insufficient_seats_error.delete_email')}
          {isGroupAdmin && !isAdminOrOwner && invitations.length - maxSeats > 1 && I18n.t('publisher.add_users_modal.insufficient_seats_error.delete_emails', {
          count: invitations.length - maxSeats
        })}
        </EmailError>}
      </FieldContainer>
    </Wrapper>;
};

require("./email_tags_field.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./email_tags_field.js");